module.exports = __webpack_public_path__ + "static/media/u.1660ab5d.png";